/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import navigation from './navigation.js';
const WOW = require('../../../node_modules/wowjs/dist/wow.js');

navigation();


const wow = new WOW.WOW(
  {
    boxClass: 'wow',      // animated element css class (default is wow)
    animateClass: 'animated', // animation css class (default is animated)
    offset: 0,          // distance to the element when triggering the animation (default is 0)
    mobile: true,       // trigger animations on mobile devices (default is true)
    live: true,       // act on asynchronously loaded content (default is true)
    callback: function (box) {
      // the callback is fired every time an animation is started
      // the argument that is passed in is the DOM node being animated
    },
    scrollContainer: null, // optional scroll container selector, otherwise use window
  }
);
wow.init();


$.fn.waitForImages = function (callback) {
  var $img = $('.lazy', this),
    totalImg = $img.length - 1;
  if (!$img.length) callback();
  var waitImgLoad = function () {
    totalImg--;
    if (!totalImg) {
      callback();
    }
  };

  $img.each(function (index, img) {
    $(img).on('load', function () {
      waitImgLoad();
    });
  });
};


var lazyload = require('lazyload');

$(function () {
  const images = $('.lazy').not('.no-lazyload');
  new lazyload(images);

  // loadImages($('.no-lazyload'));
});
//
// loadImages($images) {
//   $images.each(function () {
//     if ($(this).data('src')) {
//       $(this).attr('src', $(this).data('src'));
//       $(this).attr('loading', 'eager');
//     }
//   })
// }

$(document).ready(() => {


  $(function () {
    const images = document.querySelectorAll(".lazy");
    new lazyload(images);
  });


  $('a[href^="#"]:not(.is--no-anchor)').on('click', function (e) {

    const hash = $(this).attr('href');

    if (hash !== '#') {
      var target = $(hash);

      if (target.length) {
        e.preventDefault();
        loadImages($('.page-content img'));

        $('.page-content').waitForImages(function () {

          const scrollTop =
            $(hash).offset().top - 200;
          $('html, body').animate({scrollTop});

          window.location.hash = hash;
        });
      }
    }
  });



  function loadImages($images) {
    $images.each(function () {
      if ($(this).data('src')) {
        $(this).attr('src', $(this).data('src'));
        $(this).attr('loading', 'eager');
      }
    })
  }

  var comp = new RegExp(location.host);

  $('a[target="_blank"]').each(function() {
    if(!comp.test($(this).attr('href'))) {
      $(this).attr('rel', 'noopener');
    }
  });


});

